import { render } from "./SpeakersSection.vue?vue&type=template&id=60910fd6"
import script from "./SpeakersSection.vue?vue&type=script&lang=js"
export * from "./SpeakersSection.vue?vue&type=script&lang=js"

import "./SpeakersSection.vue?vue&type=style&index=0&id=60910fd6&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__